import { groupColor } from "../../lib/group-colors";

interface UnitMarkProps {
  groupCode: string;
  size?: "sm" | "md" | "lg";
  label?: string;
}

const SIZE_CLASSES = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-base",
  lg: "h-10 w-10 text-base",
};

function groupIcon(groupCode: string): string {
  switch (groupCode) {
    case "dlp":
      return "◫";
    case "education":
      return "★";
    case "schools":
      return "▣";
    case "care":
      return "◉";
    default:
      return "▤";
  }
}

export function UnitMark({ groupCode, size = "md", label }: UnitMarkProps) {
  const color = groupColor(groupCode);
  const initials = label?.slice(0, 2).toUpperCase();

  return (
    <span
      className={[
        "grid shrink-0 place-items-center rounded-lg font-semibold",
        SIZE_CLASSES[size],
      ].join(" ")}
      style={{
        backgroundColor: `color-mix(in srgb, ${color} 9%, white)`,
        color,
      }}
      aria-hidden={initials ? undefined : true}
    >
      {initials ?? groupIcon(groupCode)}
    </span>
  );
}
